<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      :selection="false"
      label-width="100px"
    />
  </div>
</template>

<script>
export default {
  name: 'Guanggaoguanli',
  components: {},
  data() {
    return {
      url: '/business/advertising/page',
      columns: [
        {
          label: '广告名称',
          prop: 'advName'
        },
        {
          label: '广告类型',
          prop: 'advTypeValue'
        },
        {
          label: '广告位置',
          prop: 'advLocationValue'
        },
        // {
        //   label: "投放渠道",
        //   prop: "putWay"
        // },
        {
          label: '广告状态',
          prop: 'status'
        },
        {
          label: '展示优先级',
          prop: 'showPriority'
        }
      ],
      // 操作栏
      handles: {
        width: 200,
        btns: [
          {
            label: '修改',
            icon: 'el-icon-edit',
            getLabelStyle: record => {
              const curTime = new Date()
              const end = record.deliveryEnd.replace('-', '/')
              const endTime = new Date(Date.parse(end))
              return curTime > endTime ? 'color: #c0c4cc;cursor: not-allowed' : 'color:#409EFF;'
            },
            getLabelDisabled: record => {
              const curTime = new Date()
              const end = record.deliveryEnd.replace('-', '/')
              const endTime = new Date(Date.parse(end))
              return curTime > endTime
            },
            permission: 'advertisement.update',
            handle: resp => {
              this.$router.push({ path: './reviseAd', query: { data: resp.id }})
            }
          },
          {
            label: '上架',
            permission: 'advertisement.shelves',
            style: 'color:red',
            isShowFun: record => {
              return record.soldOut
            },
            getLabelStyle: record => {
              const curTime = new Date()
              const end = record.deliveryEnd.replace('-', '/')
              const endTime = new Date(Date.parse(end))
              return curTime < endTime ? 'color:red' : 'color: #c0c4cc;cursor: not-allowed;'
            },
            getLabelDisabled: record => {
              const curTime = new Date()
              const end = record.deliveryEnd.replace('-', '/')
              const endTime = new Date(Date.parse(end))
              return curTime > endTime
            },
            isConfirm: true,
            confirmText: '是否执行此操作?',
            url: '/business/advertising/soldOut',
            method: 'post',
            before: (index, record) => {
              return {
                id: record.id
              }
            },
            handle: resp => {
              this.$refs.tableref.queryTable()
            }
          },
          {
            label: '下架',
            permission: 'advertisement.shelves',
            style: 'color:red',
            isShowFun: record => {
              return !record.soldOut
            },
            getLabelStyle: record => {
              const curTime = new Date()
              const end = record.deliveryEnd.replace('-', '/')
              const endTime = new Date(Date.parse(end))
              return curTime > endTime ? 'color: #c0c4cc;cursor: not-allowed;' : 'color:red'
            },
            getLabelDisabled: record => {
              const curTime = new Date()
              const end = record.deliveryEnd.replace('-', '/')
              const endTime = new Date(Date.parse(end))
              return curTime > endTime
            },
            isConfirm: true,
            confirmText: '下架后的广告将不在移动端展示，确认下架?',
            url: '/business/advertising/soldOut',
            method: 'post',
            before: (index, record) => {
              return {
                id: record.id
              }
            },
            handle: resp => {
              this.$refs.tableref.queryTable()
            }
          },
          {
            label: '删除',
            permission: 'advertisement.delete',
            getLabelStyle: record => {
              return record.status !== '正常已生效' ? 'color:red' : 'color: #c0c4cc;'
            },
            getLabelDisabled: record => {
              return record.status === '正常已生效'
            },
            style: 'color:red',
            isConfirm: true,
            url: '/business/advertising/delete',
            method: 'delete',
            before: (index, record) => {
              return {
                id: record.id
              }
            },
            handle: resp => {
              this.$refs.tableref.queryTable()
            }
          }
        ]
      },
      query: [
        {
          label: '广告名称',
          prop: 'advName',
          placeholder: '请输入广告名称'
        },
        {
          label: '广告类型',
          prop: 'advType',
          type: 'select',
          placeholder: '请选择广告类型',
          data: [{
            value: '0',
            label: '图片广告'
          }, {
            value: '1',
            label: '文字广告'
          }]
        },
        {
          label: '广告位置',
          prop: 'advLocation',
          type: 'select',
          placeholder: '请选择广告位置',
          data: [{
            value: '0',
            label: '首页'
          },
          {
            value: '1',
            label: '首页弹窗'
          },
          {
            value: '2',
            label: '充电界面'
          },
          {
            value: '3',
            label: '加载页广告'
          }]
        },
        {
          label: '广告主',
          prop: 'advEr',
          placeholder: '请输入广告主'
        },
        {
          label: '广告状态',
          prop: 'advState',
          type: 'select',
          placeholder: '请选择广告状态',
          data: [{
            value: '0',
            label: '正常（待生效）'
          }, {
            value: '1',
            label: '正常（已生效）'
          }, {
            value: '2',
            label: '过期下架'
          }, {
            value: '3',
            label: '手动下架'
          }]
        },
        {
          label: '优先级',
          prop: 'showPriority',
          placeholder: '请输入优先级'
        },
        {
          label: '开始时间',
          prop: 'startTime',
          type: 'date2'
        },
        {
          label: '结束时间',
          prop: 'endTime',
          type: 'date2'
        }
      ],

      toolbar: [
        {
          label: '新增',
          permission: 'advertisement.add',
          type: 'primary',
          handle: resp => {
            this.$router.push('./addAd')
          }
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    // this.getOrg()
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {

    getTreeData(data) {
      if (!data) {
        return []
      }
      for (var i = 0; i < data.length; i++) {
        if (!data[i].children) {
          return data
        }
        if (data[i].children.length === 0) {
          // children若为空数组，则将children设为undefined
          delete data[i].children
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].children)
        }
      }
      return data
    }
    // getOrg() {
    //   this.$store.dispatch("form/handle", {
    //     url: "/business/advertising/getOrgTree",
    //     method: "get",
    //     callback: resp => {
    //       this.query[3].data = this.getTreeData(resp);
    //     }
    //   });
    // }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/adManagement/admanagement.vue